import { Line } from 'react-chartjs-2';
import Chart from 'chart.js/auto';

const RatingsChartForHome = ({chartData}) => {
    const days = chartData.map((rating) => rating.rating_date);
    const data = chartData.map((rating) => rating.average_rating);

    const ratingChartForHome = () => {
        return {
          labels: days,
          datasets: [
            {
            data: data,
            label: "",
            fill: "start",
            pointRadius: 0, // Change to 0 to hide points
            borderColor: "#4caf50",
            tension: 0.4, //The smooths the line between each point
          }
        ]
        };
      };

    const options = {
        plugins: {
          legend: {
            display: false, //This hides the legend at the top of the chart
          },
        },
        scales: {
          y: {
            title: {
              display: false, // Set display to true to show the y-axis label
              text: "Rating", // The label for the y-axis
            },
            ticks: {
              color: '#4ade80', // Set the text color of y-axis tick
              stepSize: 50, // Set the tick frequency to every 20 (i.e. 1000, 1050, 1100 etc)
              autoSkip: false,
              font: {
                weight: 'bold', // Set the font weight of y-axis ticks
                size: '16px'
              },
            },
          },
          x: {
            ticks: {
              display: false,
              color: 'white', // Set the text color of x-axis ticks
            },
          }
        },
        indexAxis: 'x',
      };

    return ( 
    
            <div className='w-full h-full flex flex-col justify-center items-center'>
                <div className='w-full px-2 md:px-0'>
                <Line data={ratingChartForHome()} options={{...options, responsive: true}}/>
                </div>
            </div>
    
     );
}
 
export default RatingsChartForHome;